import { fetchPersea } from "@/config/axios/config-axios";

export const getParticipantByCampaignId = async (params = {}) => {
  return await fetchPersea(`/plug_and_play/campaign/participant`, 'GET', params);
};

export const createParticipantByCampaignId = async (body = {}) => {
  return await fetchPersea(`/plug_and_play/campaign/participant`, 'POST', {}, body);
};

export const getProgressParticipantByCampaignId = async (params = {}) => {
  const isSent = window.localStorage.getItem('is-sent-survey') ?? false;
  const newParams = {
    ...params,
    ...(isSent && { cache: false })
  };
  return await fetchPersea(`/campaign/mission/progress`, 'GET', newParams);
};
